import { render } from "./formbasicinput.vue?vue&type=template&id=267ced80"
import script from "./formbasicinput.vue?vue&type=script&lang=js"
export * from "./formbasicinput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__